// Tasks Tour
// Creating, assigning and completing tasks tied to contacts
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_contacts); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const tasksTour = {
  id: 'tasks',
  name: 'Tasks Tour',
  displayName: 'Never Drop A Follow-Up',
  description: 'Creating, assigning and completing tasks tied to contacts',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_contacts',
      popover: {
        title: "✅ Welcome to Tasks",
        description: `
          Tasks are the small human commitments that fall through the cracks — call this person back, send that quote. Here they are attached to the contact, with a due date and an owner.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "➕ Create a Task",
        description: `
          Add a task from the contact record with a **title**, **due date**, and **assignee**. Write the title as an action ("Call about renewal quote"), not a topic — future you will thank you.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "👤 Assign an Owner",
        description: `
          Every task needs one owner. Shared responsibility means nobody does it. Assign to a person, not a team.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🤖 Create Tasks Automatically",
        description: `
          The real power: have a **workflow** create the task. A high-value form submission or a stalled deal can generate a follow-up task without anyone remembering.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📋 Work Your List",
        description: `
          Filter tasks by owner and due date to see what is actually due. A task list you trust is one you clear daily; one full of overdue noise gets ignored.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔔 Reminders",
        description: `
          Notifications tell owners what is due. Keep them meaningful — alerts that fire constantly train people to dismiss them.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Nothing Falls Through",
        description: `
          You can now:

✅ Create tasks on the contact
✅ Assign a single clear owner
✅ Generate tasks from workflows
✅ Work a filtered daily list

**Next:** add a task to your most important open deal right now.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
